import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteEOI } from '~/services/AgentHub/AgentService';

export function useDeleteEoi() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      return await deleteEOI(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['list-eoi'] });
    },
  });
}
